import React from "react";

export const ProfileSVGComponent = () => (
    <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13 1C19.6273 1 25 6.37273 25 13C25 19.6273 19.6273 25 13 25C6.37273 25 1 19.6273 1 13C1 6.37273 6.37273 1 13 1V1Z"
            stroke="#242E35"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.9984 17.3632V17.3632C10.5886 17.3632 8.63477 15.4094 8.63477 12.9996V10.8177C8.63477 8.40792 10.5886 6.4541 12.9984 6.4541C15.4082 6.4541 17.362 8.40792 17.362 10.8177V12.9996C17.362 15.4094 15.4082 17.3632 12.9984 17.3632V17.3632Z"
            stroke="#242E35"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M19 23.5C17.9182 22.0251 16.2748 20.5 14.4731 20.5H11.5227C9.70632 20.5 8.08277 21.9967 7 23.492"
            stroke="#242E35"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);
